import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';

export const $IsMobileUser = atom((get) => {
  const { isBot, isMobile } = get($UserAgent);

  return !isBot && isMobile;
});

export const $IsPCUser = atom((get) => {
  const { isBot, isMobile } = get($UserAgent);
  return !isBot && !isMobile;
});
